"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_METRIC_VALUE = exports.EVENT_NAMES = exports.DYNAMIC_EVENT_END_SUFFIXES_REGEX_NEW = exports.DYNAMIC_EVENT_DURATION_SUFFIX_NEW = exports.DYNAMIC_EVENT_END_MARK_SUFFIX = void 0;
const webVitals_1 = require("./webVitals");
// Dynamic event name suffixes
// @todo Move these closer to where they are used?
exports.DYNAMIC_EVENT_END_MARK_SUFFIX = '_dynamicEventEndMark';
exports.DYNAMIC_EVENT_DURATION_SUFFIX_NEW = '_dynamicEventDuration';
exports.DYNAMIC_EVENT_END_SUFFIXES_REGEX_NEW = new RegExp(`(${exports.DYNAMIC_EVENT_DURATION_SUFFIX_NEW})$`);
/**
 * Event names as they will appear in the beacon payload
 */
exports.EVENT_NAMES = {
    /**
     * Event to track if Client Profiler itself was loaded and initialized
     * successfully
     */
    CLIENT_PROFILER_LOADED: 'clientProfilerLoaded',
    /**
     * Event to track how long it took for the `DOMContentLoaded` event to be
     * fired by the browser
     */
    DOM_CONTENT_LOADED: 'DOMContentLoaded',
    /**
     * Event to track the "fully loaded" time, i.e., the completion time of the
     * first network request that is followed by at least 2 sec of network
     * silence.
     */
    FULLY_LOADED: 'fullyLoaded',
    // <PERF-777> Keep the legacy TTFB event name so we can compare the old and
    // new values before replacing them.
    /**
     * Event to track the time to first byte (TTFB) for the initial page load
     * @deprecated Use `EVENT_NAMES.WEB_VITALS.TTFB` instead
     */
    TTFB: 'TTFB',
    // </PERF-777>
    /**
     * Event names for Web Vitals metrics is a simple identity object, i.e.,
     * the event name is the same as the metric name.
     *
     * @example
     *
     * ```js
     * { CLS: 'CLS', FID: 'FID', ... }
     * ```
     */
    WEB_VITALS: webVitals_1.WEB_VITALS.reduce((acc, metricName) => {
        acc[metricName] = metricName;
        // <PERF-777> Add event names for the new corrected) CLS and TTFB values
        // so we can compare the old and new values before we replace them.
        if (['CLS', 'TTFB'].includes(metricName)) {
            acc[`${metricName}Fixed`] = `${metricName}-fixed`;
        }
        // </PERF-777>
        return acc;
    }, {}),
};
/** Timestamp value representing an error */
exports.ERROR_METRIC_VALUE = -1;
